<template>
    <div
        class="overflow-hidden transition-all duration-500 ease-in-out"
        :class="{ 'max-h-[1000px] opacity-100': !isActive, 'max-h-0 opacity-0': isActive }"
    >
        <slot />
    </div>
</template>

<script setup lang="ts">
interface Props {
    isActive?: boolean;
}

withDefaults(defineProps<Props>(), {
    isActive: false,
});
</script>
